<script lang="ts">
  import type { Snippet } from "svelte"
  import { cn } from ".."
  import { getDialogRootContext } from "./DialogRoot.svelte"

  type Props = {
    class?: string
    children?: Snippet
    [key: string]: unknown
  }

  let { class: cssClass = "", children, ...restProps }: Props = $props()

  const rootCtx = getDialogRootContext()
</script>

<p
  class={cn("leading-6 text-general-primary-text font-medium-400", cssClass)}
  id={$rootCtx.descriptionId}
  {...restProps}
>
  {@render children?.()}
</p>
